import { create } from "zustand";
import type { Envelope } from "../api/types";

/** Сколько событий держим в диагностической ленте. Старые вытесняются. */
const FEED_LIMIT = 500;

export interface FeedItem {
  id: number;
  env: Envelope;
}

interface FeedState {
  feed: FeedItem[];
  push: (env: Envelope) => void;
  clear: () => void;
}

let nextId = 0;

/**
 * Диагностическая лента прочих событий шины.
 *
 * Сделки уходят в useTape, стаканы — в useBooks (см. store/dispatch.ts), сюда
 * попадает остальное: результаты команд, обновления ордеров, неизвестные типы
 * и — что важнее всего — то, что лента и стакан отвергли как неполное. Именно
 * последнее свойство и оправдывает существование панели: битое событие видно,
 * а не потеряно.
 *
 * Лента ограничена сверху осознанно: за сутки торгов через сокет проходят сотни
 * тысяч событий, и неограниченный массив съел бы память вкладки. Общий счётчик
 * полученного живёт в useConn и считает всё, чтобы обрезка не выглядела как
 * потеря данных.
 */
export const useFeed = create<FeedState>((set) => ({
  feed: [],

  push: (env) =>
    set((state) => {
      const item: FeedItem = { id: nextId++, env };
      const feed = [item, ...state.feed];
      if (feed.length > FEED_LIMIT) feed.length = FEED_LIMIT;
      return { feed };
    }),

  clear: () => set({ feed: [] }),
}));
